export const firebaseConfig = {
  apiKey: "AIzaSyAIPw55EFYZPyarT67AgwgSGSM8-j80T18",
  authDomain: "acs-autofficina.firebaseapp.com",
  projectId: "acs-autofficina",
  storageBucket: "acs-autofficina.firebasestorage.app",
  messagingSenderId: "67687771781",
  appId: "1:67687771781:web:1355cdcfbe63b891aec3ec",
  measurementId: "G-JRYJMPQ4T6"
};

export const BREAKPOINT_XS = 768 - 1;
export const BREAKPOINT_SM = 992 - 1;
export const BREAKPOINT_MD = 1400 - 1;
export const LAYOUT_XS = "XS";
export const LAYOUT_SM = "SM";
export const LAYOUT_MD = "MD";
export const LAYOUT_LG = "LG";
export const PAGESIZE = 20;